module.exports = __webpack_public_path__ + "images/landing/video-previews/hubspot_cover_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/hubspot_cover_2x.jpg
// module id = IaFL
// module chunks = 1